<template>
  <div>
    <div
      v-if="source === 'referred'"
      class="mt-3"
    >
      <EmailData
        title="Referred by"
        :value="referrerEmail"
        justify-content="justify-start"
      />
    </div>
  </div>
</template>

<script setup>
import EmailData from '@/components/Elements/Scaffold/EmailData.vue';

defineProps({
  referrerEmail: {
    type: String,
    required: false,
  },
  source: {
    type: String,
    required: true,
  },
});
</script>
